import React, {Component} from 'react';
import Styles from './style.css';
import {Link} from 'react-router-dom';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import HeaderMobileMenu from "../header-mobile-menu/component";
import {cartRegister} from "../../services/cartRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {imagesRegister} from "../../services/imagesRegister";
import ModalLang from "../modal-lang/component";
import ModalLeave from "../modal-leave/component";
import {demoRegister} from "../../services/demoRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import BoosterHeaderMobile from "../booster-header-mobile/component";
import {agentRegister} from "../../services/agentRegister";

class BoosterHeaderSecond extends Component {

    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            user: {},
            modal: false,
            lang: null,
            dropdown: false,
            temp_lang: null,
            language: false,
            leave: false,
            home: false,
            profile: false,
            languages: []
        };
        this._lang = this._lang.bind(this);
        this._leave = this._leave.bind(this);
    };

    componentWillMount() {
        this._updateUser();
        this._updateStep();
        this._updateLang();
        this._updateLanguages();
    }

    componentDidMount() {
        console.log(this.props);
    }

    _updateLang() {
        this.setState({lang: langRegister.lang()});
    }

    _updateUser() {
        let user = userRegister.get();
        if (user) {
            this.setState({
                user: user
            });
        }
    }

    _updateStep() {
        try {
            if (this.props.step) {
                this.setState({step: this.props.step});
            }
        } catch (error) {
        }
    }

    _updateLanguages() {
        let languages = JSON.parse(salesChannelRegister.get('languages'));
        if (Array.isArray(languages)) {
            this.setState({languages: languages});
        }
    }

    _profile() {
        try {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/running");
        } catch (e) {
        }
    }

    _signout() {
        if (this.state.user.email) {
            if (this.state.user.admin) {
                this.setState({home: true, leave: true, logout: true});
            } else {

                try {
                    salesChannelRegister.set('socialIcon', salesChannelRegister.get('socialIcon-salesforce'));
                    salesChannelRegister.set('socialTitle', salesChannelRegister.get('socialTitle-salesforce'));
                    salesChannelRegister.set('facebookId', salesChannelRegister.get('facebookId-salesforce'));
                    salesChannelRegister.set('instagramId', salesChannelRegister.get('instagramId-salesforce'));
                }catch (e) {}

                demoRegister.remove();
                userRegister.remove();
                agentRegister.remove();
                tokenRegister.remove();
                window.location.reload();
            }
        } else {

            try {
                salesChannelRegister.set('socialIcon', salesChannelRegister.get('socialIcon-salesforce'));
                salesChannelRegister.set('socialTitle', salesChannelRegister.get('socialTitle-salesforce'));
                salesChannelRegister.set('facebookId', salesChannelRegister.get('facebookId-salesforce'));
                salesChannelRegister.set('instagramId', salesChannelRegister.get('instagramId-salesforce'));
            }catch (e) {}

            demoRegister.remove();
            userRegister.remove();
            agentRegister.remove();
            tokenRegister.remove();
            window.location.reload();
        }
    }

    _openMenu() {
        this.child._openMenu();
    }

    _login() {
        try {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login" + "?from_path=" + this.props.history.location.pathname);
        } catch (e) {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
        }
    }

    _lang(lang) {
        try {
            if (lang) {
                langRegister.set(lang);
                cartRegister.remove();
                quotesRegister.remove();
                imagesRegister.remove();
                if (this.props.history.location.pathname.indexOf("images") !== -1) {
                    this.props.history.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
                    window.location.reload();
                } else {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
                }
            } else {
                this.setState({language: false});
            }
        } catch (e) {
            console.log(e);
        }
    }

    _setLang(prop) {
        try {
            if (prop.toLowerCase() !== langRegister.lang().toLowerCase()) {
                if (this.props.history.location.pathname.indexOf("booster") !== -1) {
                    this.setState({language: true, temp_lang: prop, dropdown: false}, () => {
                    });
                } else {
                    let string = "/" + salesChannelRegister.get('market') + "/" + langRegister.lang();
                    let re = new RegExp(string, "g");
                    let url = this.props.history.location.pathname.replace(re, '');
                    langRegister.set(prop);
                    this.props.history.location.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + url);
                    window.location.reload();
                }
            } else {
                this.setState({dropdown: false});
            }
        } catch (e) {
            console.log(e);
        }
    }

    _leave(value) {
        if (value) {
            if (this.state.home) {
                try {
                    if (this.state.user.admin) {
                        if (this.state.logout) {

                            try {
                                salesChannelRegister.set('socialIcon', salesChannelRegister.get('socialIcon-salesforce'));
                                salesChannelRegister.set('socialTitle', salesChannelRegister.get('socialTitle-salesforce'));
                                salesChannelRegister.set('facebookId', salesChannelRegister.get('facebookId-salesforce'));
                                salesChannelRegister.set('instagramId', salesChannelRegister.get('instagramId-salesforce'));
                            }catch (e) {}

                            tokenRegister.remove();
                            userRegister.remove();
                            agentRegister.remove();
                            demoRegister.remove();
                        }
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                    }
                } catch (error) {
                }
                try {
                    if (this.props.history.location.pathname.indexOf("images") !== -1) {
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                        window.location.reload();
                    } else {
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
                    }
                } catch (e) {
                }
            } else if (this.state.profile) {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/running");
            } else {
                if (this.props.history.location.pathname.indexOf("images") !== -1) {
                    imagesRegister.remove();
                    cartRegister.remove();
                    quotesRegister.remove();
                    window.location.reload();
                } else {
                    imagesRegister.remove();
                    cartRegister.remove();
                    quotesRegister.remove();
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
                }
            }
        } else {
            this.setState({leave: false});
        }
    }

    _renderText(item) {
        return langRegister.get("signup-header-two", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.language &&
                    <ModalLang setLang={this._lang} lang={this.state.temp_lang} props={this.props}/>
                }
                {
                    this.state.leave &&
                    <ModalLeave setLeave={this._leave} props={this.props}/>
                }
                <div className={Styles.header}>
                    {
                        this.state.dropdown &&
                        <div onClick={() => this.setState({dropdown: false})}
                             className={Styles.languageButtonContainerOverlay}/>
                    }
                    <div className={Styles.logoContainer}>
                        <img onClick={() => this.setState({leave: true, home: true})}
                             className={Styles.logoContainerIcon}
                             src={salesChannelRegister.get('logo')}/>
                        <img onClick={() => this.setState({leave: true, home: true})}
                             className={Styles.logoContainerIconMobile}
                             src={salesChannelRegister.get('logo_mobile')}/>
                    </div>
                    <div className={Styles.progressContainer}>
                        <div className={Styles.progressContainerInner}>
                            <div className={Styles.progressContainerLine}/>
                            <div className={Styles.progressContainerItem}>
                                {
                                    salesChannelRegister.get('name') === 'propertybooster' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active.svg")}/>
                                }
                                {
                                    salesChannelRegister.get('name') === 'boostabostad' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active_boostabostad.svg")}/>
                                }
                                {
                                    salesChannelRegister.get('name') === 'yieldlock' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active_yl.svg")}/>
                                }
                                <div className={Styles.progressContainerItemText}>
                                    {this._renderText("item_1")}
                                </div>
                            </div>
                            <div className={Styles.progressContainerItem}>
                                {
                                    this.state.step < 2 &&
                                    <div
                                        className={
                                            cx(Styles.progressContainerItemCircle,
                                                {
                                                    [Styles.progressContainerItemCircleActive]: this.state.step === 1,
                                                    [Styles.progressContainerItemCircleActiveYl]: this.state.step === 1 && salesChannelRegister.get('name') === 'yieldlock'
                                                })
                                        }
                                    />
                                }
                                {
                                    this.state.step > 1 && salesChannelRegister.get('name') === 'propertybooster' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active.svg")}/>
                                }
                                {
                                    this.state.step > 1 && salesChannelRegister.get('name') === 'boostabostad' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active_boostabostad.svg")}/>
                                }
                                {
                                    this.state.step > 1 && salesChannelRegister.get('name') === 'yieldlock' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active_yl.svg")}/>
                                }
                                <div
                                    className={
                                        cx(Styles.progressContainerItemText,
                                            {
                                                [Styles.progressContainerItemTextActive]: this.state.step === 1,
                                                [Styles.progressContainerItemTextActiveYl]: this.state.step === 1 && salesChannelRegister.get('name') === 'yieldlock'
                                            })
                                    }
                                >
                                    {this._renderText("item_2")}
                                </div>
                            </div>
                            <div className={Styles.progressContainerItem}>
                                {
                                    this.state.step < 3 &&
                                    <div
                                        className={
                                            cx(Styles.progressContainerItemCircle,
                                                {
                                                    [Styles.progressContainerItemCircleActive]: this.state.step === 2,
                                                    [Styles.progressContainerItemCircleActiveYl]: this.state.step === 2 && salesChannelRegister.get('name') === 'yieldlock'
                                                })
                                        }
                                    />
                                }
                                {
                                    this.state.step > 2 && salesChannelRegister.get('name') === 'propertybooster' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active.svg")}/>
                                }
                                {
                                    this.state.step > 2 && salesChannelRegister.get('name') === 'boostabostad' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active_boostabostad.svg")}/>
                                }
                                {
                                    this.state.step > 2 && salesChannelRegister.get('name') === 'yieldlock' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active_yl.svg")}/>
                                }
                                <div
                                    className={
                                        cx(Styles.progressContainerItemText,
                                            {
                                                [Styles.progressContainerItemTextActive]: this.state.step === 2,
                                                [Styles.progressContainerItemTextActiveYl]: this.state.step === 2 && salesChannelRegister.get('name') === 'yieldlock'
                                            })
                                    }
                                >
                                    {this._renderText("item_3")}
                                </div>
                            </div>
                            <div className={Styles.progressContainerItem}>
                                {
                                    this.state.step < 4 &&
                                    <div
                                        className={
                                            cx(Styles.progressContainerItemCircle,
                                                {
                                                    [Styles.progressContainerItemCircleActive]: this.state.step === 3,
                                                    [Styles.progressContainerItemCircleActiveYl]: this.state.step === 3 && salesChannelRegister.get('name') === 'yieldlock'
                                                })
                                        }
                                    />
                                }
                                {
                                    this.state.step > 3 && salesChannelRegister.get('name') === 'propertybooster' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active.svg")}/>
                                }
                                {
                                    this.state.step > 3 && salesChannelRegister.get('name') === 'boostabostad' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active_boostabostad.svg")}/>
                                }
                                {
                                    this.state.step > 3 && salesChannelRegister.get('name') === 'yieldlock' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active_yl.svg")}/>
                                }
                                <div
                                    className={
                                        cx(Styles.progressContainerItemText,
                                            {
                                                [Styles.progressContainerItemTextActive]: this.state.step === 3,
                                                [Styles.progressContainerItemTextActiveYl]: this.state.step === 3 && salesChannelRegister.get('name') === 'yieldlock'
                                            })
                                    }
                                >
                                    {this._renderText("item_8")}
                                </div>
                            </div>
                            <div className={Styles.progressContainerItem}>
                                {
                                    this.state.step < 5 &&
                                    <div
                                        className={
                                            cx(Styles.progressContainerItemCircle,
                                                {
                                                    [Styles.progressContainerItemCircleActive]: this.state.step === 4,
                                                    [Styles.progressContainerItemCircleActiveYl]: this.state.step === 4 && salesChannelRegister.get('name') === 'yieldlock'
                                                })
                                        }
                                    />
                                }
                                {
                                    this.state.step > 4 && salesChannelRegister.get('name') === 'propertybooster' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active.svg")}/>
                                }
                                {
                                    this.state.step > 4 && salesChannelRegister.get('name') === 'boostabostad' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active_boostabostad.svg")}/>
                                }
                                {
                                    this.state.step > 4 && salesChannelRegister.get('name') === 'yieldlock' &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active_yl.svg")}/>
                                }
                                <div
                                    className={
                                        cx(Styles.progressContainerItemText,
                                            {
                                                [Styles.progressContainerItemTextActive]: this.state.step === 4,
                                                [Styles.progressContainerItemTextActiveYl]: this.state.step === 4 && salesChannelRegister.get('name') === 'yieldlock'
                                            })
                                    }
                                >
                                    {this._renderText("item_4")}
                                </div>
                            </div>
                            <div className={Styles.progressContainerItem}>
                                <div
                                    className={
                                        cx(Styles.progressContainerItemCircle,
                                            {
                                                [Styles.progressContainerItemCircleActive]: this.state.step === 5,
                                                [Styles.progressContainerItemCircleActiveYl]: this.state.step === 5 && salesChannelRegister.get('name') === 'yieldlock'
                                            })
                                    }
                                />
                                <div
                                    className={
                                        cx(Styles.progressContainerItemText,
                                            {
                                                [Styles.progressContainerItemTextActive]: this.state.step === 5,
                                                [Styles.progressContainerItemTextActiveYl]: this.state.step === 5 && salesChannelRegister.get('name') === 'yieldlock'
                                            })
                                    }
                                >
                                    {this._renderText("item_5")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.buttonContainer}>
                        <div className={Styles.languageButtonContainer}>
                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} onClick={() => this.setState({dropdown: !this.state.dropdown})}
                                 className={Styles.languageButton}>
                                {this.state.lang}
                            </div>
                            {
                                this.state.dropdown &&
                                <div>
                                    <div className={Styles.languageButtonDropdown}>
                                        {
                                            this.state.languages.map((item) => {
                                                return (
                                                    <div onClick={() => this._setLang(item.code)}
                                                         className={Styles.languageButtonDropdownItem}>
                                                        {item.names[langRegister.lang()]}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className={Styles.languageButtonTriangle}/>
                                </div>
                            }
                        </div>
                        {
                            salesChannelRegister.get("name") !== "yieldlock" &&
                            tokenRegister.get() && !this.state.user.reseller && !this.state.user.inhouse &&
                            <img onClick={() => this.setState({leave: true, profile: true})}
                                 className={Styles.buttonContainerUserIcon}
                                 src={require("../../assets/images/user_icon.svg")}/>
                        }
                        {
                            salesChannelRegister.get("name") === "yieldlock" &&
                            tokenRegister.get() && !this.state.user.reseller && !this.state.user.inhouse &&
                            <img onClick={() => this.setState({leave: true, profile: true})}
                                 className={Styles.buttonContainerUserIcon}
                                 src={require("../../assets/images/user_icon_yl.svg")}/>
                        }
                        {
                            salesChannelRegister.get("name") !== "yieldlock" &&
                            tokenRegister.get() && (this.state.user.reseller || this.state.user.inhouse) &&
                            <img onClick={() => this.setState({leave: true, profile: true})}
                                 className={Styles.buttonContainerUserIcon}
                                 src={require("../../assets/images/user_icon_reseller.svg")}/>
                        }
                        {
                            salesChannelRegister.get("name") === "yieldlock" &&
                            tokenRegister.get() && (this.state.user.reseller || this.state.user.inhouse) &&
                            <img onClick={() => this.setState({leave: true, profile: true})}
                                 className={Styles.buttonContainerUserIcon}
                                 src={require("../../assets/images/user_icon_reseller_yl.svg")}/>
                        }
                        {
                            !tokenRegister.get() &&
                            <div onClick={() => this._login()} className={Styles.buttonContainerSignIn}>
                                {this._renderText("item_6")}
                            </div>
                        }
                        {
                            tokenRegister.get() &&
                            <div onClick={() => this._signout()} className={Styles.buttonContainerSignIn}>
                                {this._renderText("item_7")}
                            </div>
                        }
                        <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu}
                             src={require("../../assets/images/menu_icon.svg")}/>
                    </div>
                    <BoosterHeaderMobile props={this.props.props} ref={instance => {
                        this.child = instance
                    }} layout={true}/>
                </div>
            </div>
        );
    }
}

export default BoosterHeaderSecond;


// WEBPACK FOOTER //
// ./src/components/booster-header-second/component.js